import { apiCall } from "api-calls/api-call"
import {
  GameModeMultiplier,
  CreateGameModeMultiplierDto,
  UpdateGameModeMultiplierDto,
  BulkUpsertGameModeMultipliersDto,
} from "../store/types"


export const getAllGameModeMultipliers = async(): Promise<GameModeMultiplier[]> => {

  return apiCall({
    method: "GET",
    path: "games-v2/game-mode-multipliers",
  })
}

export const getGameModeMultipliersByGame = async(gameId: string): Promise<GameModeMultiplier[]> => {


  return apiCall({
    method: "GET",
    path: "games-v2/game-mode-multipliers",
    query: { gameId: Number(gameId) },
  })
}

export const createGameModeMultiplier = async(data: CreateGameModeMultiplierDto): Promise<GameModeMultiplier> => {

  return apiCall({
    method: "POST",
    path: "games-v2/game-mode-multipliers",
    body: data,
  })
}

export const updateGameModeMultiplier = async(id: string, data: UpdateGameModeMultiplierDto): Promise<GameModeMultiplier> => {

  return apiCall({
    method: "PUT",
    path: `games-v2/game-mode-multipliers/${id}`,
    body: data,
  })
}

export const deleteGameModeMultiplier = async(id: string): Promise<void> => {

  return apiCall({
    method: "DELETE",
    path: `games-v2/game-mode-multipliers/${id}`,
  })
}

export const bulkUpsertGameModeMultipliers = async(data: BulkUpsertGameModeMultipliersDto): Promise<GameModeMultiplier[]> => {

  return apiCall({
    method: "POST",
    path: "games-v2/game-mode-multipliers/bulk-upsert",
    body: data,
  })
}
